import {EditModel} from "./EditModel";
import {Location} from "../../entities/Location";
import {LocationService} from "../../services/LocationService";
import {PrintJobService} from "../../services/PrintJobService";
import {NotificationService} from "../../services/NotificationService";
import {Asset} from "../../entities/Asset";
import {Template} from "../../entities/Template";
import {PrintJob} from "../../entities/PrintJob";

export class EditLocationModel extends EditModel<Location> {
    entityId:number;
    static $inject = ['$q','LocationService','PrintJobService','NotificationService'];
    constructor($q:ng.IQService, public service:LocationService,
                public printjobService:PrintJobService, public notifyService:NotificationService){
        super($q, service, Location);
    }
    verifyData():ng.IPromise<boolean>{
      if(this.entity.name == null || this.entity.name.length == 0){
        this.notifyService.notifyError("Name is required.");
        return this.$q.when<boolean>(false);
      }
      var rfidPromise = this.entity.rfidTag != null && this.entity.rfidTag.length > 0 ? this.service.getByRfid(this.entity.rfidTag) : this.$q.when<Asset>(null);
      return this.$q.all([this.service.getByName(this.entity.name),rfidPromise]).then((data)=>{
        var nameLocation:Location = data[0];
        var rfidLocation:Location = data[1];
        if(nameLocation != null && nameLocation.id != this.entity.id)
        {
          this.notifyService.notifyError("Please choose a unique location name.");
          return this.$q.when<boolean>(false);
        }
        else if(rfidLocation != null && rfidLocation.id != this.entity.id)
        {
          this.notifyService.notifyError("This RFID value is already associated with location "+rfidLocation.name);
          return this.$q.when<boolean>(false);
        }
        else
          return this.$q.when<boolean>(true);
      })
    }
    print(template:Template){
        var mainPromise:ng.IPromise<any> = null;
        if(this.entityId == null)
            mainPromise = this.service.insert(this.entity);
        else
            mainPromise = this.$q.when<number>(this.entityId);
        mainPromise.then((entityId)=>{
            if(this.entityId == null)
                this.entity.id=entityId;
            this.entityId = entityId;
            var printJob: PrintJob = new PrintJob(null, this.entity.id, "Location", template.id, template.useWithService);
          return this.printjobService.print(printJob);
        })
            .then((newId) => {
                return this.printjobService.get(newId).then((printJob) => {
                    this.entity.rfidTag = printJob.generatedRfid;
                })                
                this.notifyService.notify("Print Job Scheduled Successfully.");
            })
            .catch((exc)=>{
                this.notifyService.notifyError("Printing Error",exc);
            });
    }
}
